<template>
    <div class="divider">
        <slot />
    </div>
</template>

<style scoped lang="scss">
.divider {
    &-vertical {
        width: 100%;
        height: 1px;
        background-color: #cbcbcb;
    }

    &-horizontal {
        width: 1px;
        height: auto;
        background-color: #cbcbcb;
    }

    &-with-text {
        position: relative;
        width: 100%;
        text-align: center;
        height: 24px;

        .divider-text {
            position: absolute;
            top: 50%;
            left: 50%;
            padding: 0 16px;
            background-color: #fff;
            transform: translate(-50%, -50%);
        }

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            border: 1px solid #e3e3e3;
            transform: translateY(-50%);
        }
    }
}
</style>

